import { render, staticRenderFns } from "./SpecificationTab.vue?vue&type=template&id=7c511051&"
import script from "./SpecificationTab.vue?vue&type=script&lang=ts&"
export * from "./SpecificationTab.vue?vue&type=script&lang=ts&"
import style0 from "./SpecificationTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports